import {
    createLogscordPublicSite,
} from "@logscord/public-site-config";


export const PublicSite = createLogscordPublicSite({
    siteUrl: import.meta.env["VITE_PUBLIC_SITE_URL"],
});
